import { render, staticRenderFns } from "./dynamic_details.vue?vue&type=template&id=5a343b32&scoped=true&"
import script from "./dynamic_details.vue?vue&type=script&lang=js&"
export * from "./dynamic_details.vue?vue&type=script&lang=js&"
import style0 from "./dynamic_details.vue?vue&type=style&index=0&id=5a343b32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a343b32",
  null
  
)

export default component.exports